const styObj = {
  default: {
    '--pay-font': 'Inter-TightRegular',
    // 顶导航条与整页画布（.custom-nav-block、.container-pay）
    '--pay-shell-bg': '#f9f9fb',
    // 导航栏左侧标题文案（.tit-left）
    '--pay-nav-title': '#333333',
    // 余额区大号金币总数（.amount）
    '--pay-balance-sum': '#333333',
    // 赠礼/道具行每项说明（.dis-item）
    '--pay-gift-row': '#666666',
    // 余额下方浅灰提示段落（.tips-one）
    '--pay-soft-note': '#b2b2b2',
    // 「Methods」等区块标题（.block-title）
    '--pay-block-heading': '#333333',
    // 优惠券入口卡片底板（.coupons-block、.show-item）
    '--pay-coupon-fill': '#fefefe',
    // 优惠券入口可用态主文案（.coupon-logo span、下拉券描述）
    '--pay-coupon-text': '#666666',
    // 优惠券无可用/不可用态文案（.no-valid-info 等）
    '--pay-coupon-dim': '#b2b2b2',
    // 支付方式白卡片、优惠券下拉浮层底板（.method-item、.coupon-scroll）
    '--pay-panel-fill': '#ffffff',
    // 支付方式图标凹槽、下拉券选中浅底（.method-img、coupon-active 列表行）
    '--pay-thumb-well': '#f9f9fb',
    // 支付方式上「折扣」角标底板（.method-mark.discount）
    '--pay-chip-sale-fill': 'rgba(255, 66, 101, 0.05)',
    // 支付方式上折扣角标字色（.method-mark.discount）
    '--pay-chip-sale-text': '#f95151',
    // 「上次使用」等小角标底板（.method-mark.last-used）
    '--pay-chip-used-fill': 'rgba(255, 187, 40, 0.10)',
    // 「上次使用」等小角标字色
    '--pay-chip-used-text': '#C36F00',
    // 最优支付方式底部横幅字色（MyPLabel.method-tips）
    '--pay-best-banner-text': '#ffffff',
    // 支付方式名称（.method-name .name）
    '--pay-method-name': '#333333',
    // 支付方式单价（.rate）
    '--pay-method-price': '#333333',
    // 品牌主色：最优横幅底、焦点描边.method-on、底部主按钮底色
    '--pay-accent-brand': '#a338fc',
    // 支付方式下方提示折叠区整块背景（.method-tip-section）
    '--pay-tip-bg': '#FAEDFF',
    // 提示区标题行前段（👉🏻 + tipTitle，.tip-title）
    '--pay-tip-title': '#6849A6',
    // 提示区展开正文（.tip-body）
    '--pay-tip-body': '#6849A6',
    // 底部固定提交栏半透明底（.submit-btn-block）
    '--pay-footer-scrim': 'rgba(249, 249, 251, 0.8)',
    // 底部主按钮药丸圆角（.submit-btn）
    '--pay-cta-radius': '100px',
    // 底部主按钮文案色（.submit-btn）
    '--pay-cta-text': '#ffffff',
    // 优惠券入口、券列表、支付方式提示等处折叠箭头（.tip-arrow）
    '--pay-icon-chevron': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    // 优惠券下拉项已选勾（列表内 .coupon-check.checked）
    '--pay-icon-coupon-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check.webp')})`,
    // 优惠券下拉项未选圆圈
    '--pay-icon-coupon-off': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    // 支付方式右上角选中角标（LTR，.method-check.checked）
    '--pay-icon-method-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon.webp')})`,
    // 同上，RTL（html[lang=ar|fa|he]）
    '--pay-icon-method-on-rtl': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon-ar.webp')})`,
  },
  echo: {
    '--pay-shell-bg': '#f4f5f7',
    '--pay-font': 'Outfit-Regular',
    '--pay-nav-title': '#222222',
    '--pay-balance-sum': '#222222',
    '--pay-gift-row': '#222222',
    '--pay-soft-note': '#999999',
    '--pay-block-heading': '#222222',
    '--pay-coupon-fill': '#fefefe',
    '--pay-coupon-text': '#222222',
    '--pay-coupon-dim': '#aeaeb2',
    '--pay-panel-fill': '#ffffff',
    '--pay-thumb-well': '#f9f9fb',
    '--pay-chip-sale-fill': 'rgba(255, 66, 101, 0.05)',
    '--pay-chip-sale-text': '#f95151',
    '--pay-chip-used-fill': 'rgba(255, 187, 40, 0.10)',
    '--pay-chip-used-text': '#C36F00',
    '--pay-best-banner-text': '#ffffff',
    '--pay-method-name': '#222222',
    '--pay-method-price': '#222222',
    '--pay-accent-brand': '#ff7f2d',
    '--pay-tip-bg': '#FFF7EA',
    '--pay-tip-title': '#FF7F2D',
    '--pay-tip-body': '#FF7F2D',
    '--pay-footer-scrim': 'rgba(255, 255, 255, 0.8)',
    '--pay-cta-radius': '100px',
    '--pay-cta-text': '#ffffff',
    '--pay-icon-chevron': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon-coupon-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check.webp')})`,
    '--pay-icon-coupon-off': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon-method-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-icon.webp')})`,
    '--pay-icon-method-on-rtl': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-icon-ar.webp')})`,
  },
  joychat: {
    '--pay-font': 'Lato-Regular',
    '--pay-shell-bg': '#f9f9fb',
    '--pay-nav-title': '#222222',
    '--pay-balance-sum': '#222222',
    '--pay-gift-row': '#222222',
    '--pay-soft-note': '#999999',
    '--pay-block-heading': '#222222',
    '--pay-coupon-fill': '#fefefe',
    '--pay-coupon-text': '#666666',
    '--pay-coupon-dim': '#aeaeb2',
    '--pay-panel-fill': '#ffffff',
    '--pay-thumb-well': '#f9f9fb',
    '--pay-chip-sale-fill': 'rgba(255, 66, 101, 0.05)',
    '--pay-chip-sale-text': '#f95151',
    '--pay-chip-used-fill': 'rgba(255, 187, 40, 0.10)',
    '--pay-chip-used-text': '#C36F00',
    '--pay-best-banner-text': '#ffffff',
    '--pay-method-name': '#222222',
    '--pay-method-price': '#222222',
    '--pay-accent-brand': '#22c185',
    '--pay-tip-bg': '#D7FFEE',
    '--pay-tip-title': '#063D28',
    '--pay-tip-body': '#063D28',
    '--pay-footer-scrim': 'rgba(249, 249, 251, 0.8)',
    '--pay-cta-radius': '100px',
    '--pay-cta-text': '#ffffff',
    '--pay-icon-chevron': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon-coupon-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check.webp')})`,
    '--pay-icon-coupon-off': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon-method-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-icon.webp')})`,
    '--pay-icon-method-on-rtl': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-icon-ar.webp')})`,
  },
  joyu: {
    '--pay-shell-bg': '#F4F5F7',
    '--pay-font': 'NotoSans-Regular',
    '--pay-nav-title': '#0C0E11',
    '--pay-balance-sum': '#0C0E11',
    '--pay-gift-row': '#353A3F',
    '--pay-soft-note': '#8E9092',
    '--pay-block-heading': '#0C0E11',
    '--pay-coupon-fill': '#ffffff',
    '--pay-coupon-text': '#353A3F',
    '--pay-coupon-dim': '#8E9092',
    '--pay-panel-fill': '#ffffff',
    '--pay-thumb-well': '#F4F5F7',
    '--pay-chip-sale-fill': 'rgba(255, 66, 101, 0.05)',
    '--pay-chip-sale-text': '#FF5526',
    '--pay-chip-used-fill': 'rgba(255, 187, 40, 0.10)',
    '--pay-chip-used-text': '#C36F00',
    '--pay-best-banner-text': '#5A0B1B',
    '--pay-method-name': '#0C0E11',
    '--pay-method-price': '#353A3F',
    '--pay-accent-brand': '#FF6A55',
    '--pay-tip-bg': '#FFECDD',
    '--pay-tip-title': '#5A0B1B',
    '--pay-tip-body': '#5A0B1B',
    '--pay-footer-scrim': 'transparent',
    '--pay-cta-radius': '4px',
    '--pay-cta-text': '#5A0B1B',
    '--pay-icon-chevron': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon-coupon-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check.webp')})`,
    '--pay-icon-coupon-off': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon-method-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-icon.webp')})`,
    '--pay-icon-method-on-rtl': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-icon-ar.webp')})`,
  },
  kiko: {
    '--pay-shell-bg': '#f9f9fb',
    '--pay-font': 'Inter-Tight',
    '--pay-nav-title': '#333333',
    '--pay-balance-sum': '#333333',
    '--pay-gift-row': '#666666',
    '--pay-soft-note': '#b2b2b2',
    '--pay-block-heading': '#333333',
    '--pay-coupon-fill': '#fefefe',
    '--pay-coupon-text': '#666666',
    '--pay-coupon-dim': '#b2b2b2',
    '--pay-panel-fill': '#ffffff',
    '--pay-thumb-well': '#f9f9fb',
    '--pay-chip-sale-fill': 'rgba(255, 66, 101, 0.05)',
    '--pay-chip-sale-text': '#f95151',
    '--pay-chip-used-fill': 'rgba(255, 187, 40, 0.10)',
    '--pay-chip-used-text': '#C36F00',
    '--pay-best-banner-text': '#000000',
    '--pay-method-name': '#333333',
    '--pay-method-price': '#333333',
    '--pay-accent-brand': '#ffe242',
    '--pay-tip-bg': '#FFFCE6',
    '--pay-tip-title': '#937A15',
    '--pay-tip-body': '#937A15',
    '--pay-footer-scrim': 'rgba(249, 249, 251, 0.8)',
    '--pay-cta-radius': '100px',
    '--pay-cta-text': '#000000',
    '--pay-icon-chevron': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon-coupon-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check.webp')})`,
    '--pay-icon-coupon-off': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon-method-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-icon.webp')})`,
    '--pay-icon-method-on-rtl': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-icon-ar.webp')})`,
  },
  vava: {
    '--pay-shell-bg': '#f9f9fb',
    '--pay-font': 'Inter-Tight',
    '--pay-nav-title': '#333333',
    '--pay-balance-sum': '#333333',
    '--pay-gift-row': '#666666',
    '--pay-soft-note': '#b2b2b2',
    '--pay-block-heading': '#333333',
    '--pay-coupon-fill': '#fefefe',
    '--pay-coupon-text': '#666666',
    '--pay-coupon-dim': '#b2b2b2',
    '--pay-panel-fill': '#ffffff',
    '--pay-thumb-well': '#f9f9fb',
    '--pay-chip-sale-fill': 'rgba(255, 66, 101, 0.05)',
    '--pay-chip-sale-text': '#f95151',
    '--pay-chip-used-fill': 'rgba(255, 187, 40, 0.10)',
    '--pay-chip-used-text': '#C36F00',
    '--pay-best-banner-text': '#ffffff',
    '--pay-method-name': '#333333',
    '--pay-method-price': '#333333',
    '--pay-accent-brand': '#a338fc',
    '--pay-tip-bg': '#FAEDFF',
    '--pay-tip-title': '#6849A6',
    '--pay-tip-body': '#6849A6',
    '--pay-footer-scrim': 'rgba(249, 249, 251, 0.8)',
    '--pay-cta-radius': '100px',
    '--pay-cta-text': '#ffffff',
    '--pay-icon-chevron': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon-coupon-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check.webp')})`,
    '--pay-icon-coupon-off': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon-method-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon.webp')})`,
    '--pay-icon-method-on-rtl': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon-ar.webp')})`,
  },
  vibeo: {
    '--pay-shell-bg': '#f9f9fb',
    '--pay-font': 'Inter-Tight',
    '--pay-nav-title': '#333333',
    '--pay-balance-sum': '#333333',
    '--pay-gift-row': '#666666',
    '--pay-soft-note': '#b2b2b2',
    '--pay-block-heading': '#333333',
    '--pay-coupon-fill': '#fefefe',
    '--pay-coupon-text': '#666666',
    '--pay-coupon-dim': '#b2b2b2',
    '--pay-panel-fill': '#ffffff',
    '--pay-thumb-well': '#f9f9fb',
    '--pay-chip-sale-fill': 'rgba(255, 66, 101, 0.05)',
    '--pay-chip-sale-text': '#f95151',
    '--pay-chip-used-fill': 'rgba(255, 187, 40, 0.10)',
    '--pay-chip-used-text': '#C36F00',
    '--pay-best-banner-text': '#733406',
    '--pay-method-name': '#333333',
    '--pay-method-price': '#333333',
    '--pay-accent-brand': '#ffa433',
    '--pay-tip-bg': '#FFF4D6',
    '--pay-tip-title': '#733406',
    '--pay-tip-body': '#733406',
    '--pay-footer-scrim': 'rgba(249, 249, 251, 0.8)',
    '--pay-cta-radius': '100px',
    '--pay-cta-text': '#733406',
    '--pay-icon-chevron': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon-coupon-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check.webp')})`,
    '--pay-icon-coupon-off': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon-method-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-icon.webp')})`,
    '--pay-icon-method-on-rtl': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-icon-ar.webp')})`,
  },
  whonow: {
    '--pay-shell-bg': '#F4F5F7',
    '--pay-font': 'Manrope-Regular',
    '--pay-nav-title': '#0C0E11',
    '--pay-balance-sum': '#222222',
    '--pay-gift-row': '#666666',
    '--pay-soft-note': '#999999',
    '--pay-block-heading': '#222222',
    '--pay-coupon-fill': '#ffffff',
    '--pay-coupon-text': '#222222',
    '--pay-coupon-dim': '#8E9092',
    '--pay-panel-fill': '#ffffff',
    '--pay-thumb-well': '#f9f9fb',
    '--pay-chip-sale-fill': 'rgba(255, 66, 101, 0.05)',
    '--pay-chip-sale-text': '#F95151',
    '--pay-chip-used-fill': 'rgba(255, 187, 40, 0.10)',
    '--pay-chip-used-text': '#C36F00',
    '--pay-best-banner-text': '#0C0E11',
    '--pay-method-name': '#222222',
    '--pay-method-price': '#222222',
    '--pay-accent-brand': '#B9E86F',
    '--pay-tip-bg': '#EAF5C8',
    '--pay-tip-title': '#102006',
    '--pay-tip-body': '#102006',
    '--pay-footer-scrim': '#ffffff',
    '--pay-cta-radius': '100px',
    '--pay-cta-text': '#102006',
    '--pay-icon-chevron': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp')})`,
    '--pay-icon-coupon-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check.webp')})`,
    '--pay-icon-coupon-off': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.webp')})`,
    '--pay-icon-method-on': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-icon.webp')})`,
    '--pay-icon-method-on-rtl': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-icon-ar.webp')})`,
  },
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置
        else {
          return styObj['default']
        }
      }
      return {}
    },
  },
}
